import React from "react";
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import HeadPage from "./component/HeadPage";
import Confirm from './modal/confirm';
import CancelNilai from './modal/cancelNilaiTeacher';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey } from '@fortawesome/free-solid-svg-icons';
import { ClipLoader, PulseLoader} from "react-spinners";
import { FiTrash2 } from "react-icons/fi";

/* ===========================
   🔥 SKELETON SHIMMER STYLE
=========================== */
const shimmerStyle = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;
    background: #f6f7f8;
    background: linear-gradient(
      to right,
      #ddeaffff 8%,
      #f4f8ffff 18%,
      #ddeaffff 33%
    );
    background-size: 800px 104px;
  }
  .shimmer-select {
    height: 35px;
    border-radius: 4px;
  }
  .shimmer-row {
    height: 38px;
  }

  /* ✅ ROW HOVER: input border ikut berwarna */
  .ysb-score-input{
    transition: border-color .12s ease, box-shadow .12s ease;
  }
  .ysb-row-hover:hover .ysb-score-input{
    border-color:#c0d2f1 !important;
  }
  .ysb-row-hover:hover .ysb-score-input:not(.ysb-input-disabled){
    box-shadow: 0 0 0 2px rgba(215, 226, 255, 0.18);
  } 
  .ysb-row-hover:hover .ysb-score-input.ysb-input-disabled{
    border-color:#cbd5e1 !important;
    box-shadow:none;
  }

  /* =========================================================
   MODE HANYA LIHAT
   Developer & Pengawas Adab
  ========================================================= */

  .head-assessment-readonly-banner {
    display: flex;
    width: 100%;
    align-items: flex-start;
    gap: 11px;

    margin: 4px 0 14px;
    padding: 12px 14px;

    border: 1px solid #f0d79d;
    border-radius: 11px;

    background: #fffaf0;
    color: #7d5a16;

    font-size: 12.5px;
    line-height: 1.55;
  }

  .head-assessment-readonly-banner strong {
    display: block;
    margin-bottom: 2px;

    color: #6f4c0d;
    font-size: 12.5px;
    font-weight: 700;
  }

  .head-assessment-readonly-icon {
    display: inline-flex;

    width: 21px;
    height: 21px;
    flex: 0 0 21px;

    align-items: center;
    justify-content: center;

    margin-top: 1px;

    border-radius: 50%;

    background: #f0aa36;
    color: #ffffff;

    font-size: 12px;
    font-weight: 800;
  }


  /* INPUT DISABLED */

  .head-assessment-table .ysb-score-input:disabled,
  .head-assessment-table .ysb-score-input.ysb-input-disabled {
    cursor: not-allowed !important;

    border-color: #e0e5ee !important;

    background: #f2f4f7 !important;

    color: #9aa4b7 !important;

    box-shadow: none !important;

    opacity: 1 !important;
  }

  .head-assessment-table .ysb-score-input:disabled:hover,
  .head-assessment-table .ysb-score-input.ysb-input-disabled:hover {
    border-color: #e0e5ee !important;
    background: #f2f4f7 !important;
  }

  `;


export default function Dimensi() {
  document.title = "Penilaian";

  // const [savingId, setSavingId] = useState(null);
  const [savingKey, setSavingKey] = useState(null);

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");
  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  const [loading, setLoading] = useState(false);

  const [loadingDimensi, setLoadingDimensi] = useState(true);

  const [loadingSchool, setLoadingSchool] = useState(false);
  const firstLoadDone = useRef(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");

  // SEARCH 
  const [searchMap, setSearchMap] = useState({});

  // Data master
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [getDataGradeLevel, setGetDataGradeLevel] = useState([]);

  const [loadingGradeLevel, setLoadingGradeLevel] = useState(false);

  // Table data
  const [getData, setGetData] = useState([]);

  // UI state
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  // Filter form
  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id: "",
  });

  const selectedSemester = useMemo(
    () =>
      getDataSemesterMap.find(
        (semester) => String(semester?.id) === String(form2?.ysb_semester_id)
      ) || null,
    [getDataSemesterMap, form2?.ysb_semester_id]
  );

  const isSelectedSemesterActive = Number(selectedSemester?.status) === 1;

  // EDIT nilai
  const [form3, setForm3] = useState({
    ysb_element_recap_id_id: "",
    ysb_sub_element_value: "",
  });

  const [updateId, setUpdateID] = useState(null);
  const [scorePicker, setScorePicker] = useState({
      open: false,
      recapId: null,
      top: 0,
      left: 0,
      meta: null,
    });
  const id_user = localStorage.getItem("id_admin") || "";
  const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");

  // Permission
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems = JSON.parse(localStorage.getItem("role_permission")) || [];
    if (level === "developer" || level === "superadmin") {
      setPermission({ create: 1, read: 1, update: 1, delete: 1 });
      return;
    }
    const foundPermission = storageItems.find((item) => item.menu?.url === location.pathname);
    if (!foundPermission) navigate("/dashboard");
    else {
      setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
      });
    }
  }, [location.pathname, navigate]);

  /* API HEADERS */
  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  // ---------- helper refs ----------
  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((c) => c.abort());
    };
  }, []);

  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  const ysbRoleName =
  localStorage.getItem(
    "ysb_role_name"
  );

const normalizedRoleName =
  String(ysbRoleName || "")
    .trim()
    .toLowerCase();

const normalizedLevel =
  String(storageLevel || "")
    .trim()
    .toLowerCase();

const isPengawasAdab =
  normalizedRoleName ===
  "pengawas adab";

const isDeveloper =
  normalizedLevel ===
  "developer";


  const isNilaiReadOnlyRole =
  isDeveloper ||
  isPengawasAdab;

  // SORT sekolah
  const sortSchools = (schools) => {
    const order = ["SD", "SMP", "SMA"];
    return [...schools].sort((a, b) => {
      const jenjangA = order.findIndex((j) => (a.school_name || "").toUpperCase().includes(j));
      const jenjangB = order.findIndex((j) => (b.school_name || "").toUpperCase().includes(j));
      return jenjangA - jenjangB;
    });
  };

  const removeBasementBekasi = (schools, branchId) => {
    if (branchId === "BKS") return schools.filter((s) => s.school_code !== "BASEMENT_BEKASI");
    return schools;
  };

  const getCellKey = (meta = {}) =>
  `${safeStr(meta?.ysb_student_id)}__${safeStr(meta?.ysb_sub_element_id)}`;


const resolveCreatedRecapId = (response) => {
    return (
      response?.data?.data?.id ||
      response?.data?.data?.ysb_element_recap_id ||
      response?.data?.data?.ysb_element_recap_teacher_id ||
      response?.data?.data?.ysb_recap_id ||
      response?.data?.id ||
      response?.data?.ysb_element_recap_id ||
      response?.data?.ysb_element_recap_teacher_id ||
      null
    );
  };

  const updateLocalCellValue = (prevData, meta, value, newRecapId = null) => {
    const copy = JSON.parse(JSON.stringify(prevData || []));

    copy.forEach((group) => {
      (group?.data_element || []).forEach((el) => {
        (el?.rekapan || []).forEach((rekap) => {
          const sameStudent =
            safeStr(rekap?.ysb_student_id) === safeStr(meta?.ysb_student_id);

          let touched = false;

          (rekap?.sub_elements || []).forEach((sub) => {
            const sameSubElement =
              safeStr(sub?.ysb_sub_element_id) === safeStr(meta?.ysb_sub_element_id);

            if (sameStudent && sameSubElement) {
              sub.ysb_sub_element_value =
                value === "" || value === null || value === undefined
                  ? null
                  : Number(value);

              if (newRecapId) {
                sub.ysb_element_recap_id = newRecapId;
              }

              touched = true;
            }
          });

          if (touched) {
            rekap.average = calculateAverage(rekap?.sub_elements || []);
          }
        });
      });
    });

    return copy;
  };
  // =========================
  // INIT: Branch + Semester + Dimensi
  // =========================
  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [branchRes, semesterRes] = await Promise.all([
        APIMS.get(
          `/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`,
          { ...fetchParams, signal: controller.signal }
        ),
        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
      ]);

      if (!isMounted.current) return;

      // Branch default pertama
      if (branchRes?.status === 200) {
        const branches = branchRes.data.data || [];
        setGetDataBranch(branches);
        if (branches.length > 0) {
          const firstBranch = branches[0].branch_code;
          setForm2((prev) => ({ ...prev, ysb_branch_id: firstBranch }));
        }
      }

      // Semester aktif
      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        const active = semesters.find((s) => Number(s?.status) === 1) || semesters[0];
        setGetDataSemesterMap(semesters);
        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");
          setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
        }
      }

    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || err.message || "Error",
        icon: "error",
      });
    } 
  }, [ascending, descending, fetchParams, keyword, limit, page, storageBranchGroping, storageLevel]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  // =========================
  // Fetch sekolah saat branch berubah
  // =========================
  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      setLoadingSchool(true); 
      try {
        const res = await APIMS.get(
          `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );
        if (res?.status === 200) {
          let schools = res.data.data || [];

          // filter untuk developer
          if (storageLevel === "developer" || storageLevel === "superadmin") {
            schools = schools.filter(
              (s) => s.ysb_branch_id === branchId
            );
          }

          schools = removeBasementBekasi(schools, branchId);
          schools = sortSchools(schools);

          setGetDataSchool(schools);

          // default sekolah pertama
          if (schools.length > 0) {
            setForm2((prev) => ({
              ...prev,
              ysb_school_id: schools[0].school_code,
            }));
          } else {
            setForm2((prev) => ({ ...prev, ysb_school_id: "", ysb_grade_level_id: "" }));
            setGetDataGradeLevel([]);
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoadingSchool(false); 
        setLoading(false);       
      }
    },
    [ascending, fetchParams, limit, page, storageLevel]
  );

  useEffect(() => {
    if (form2.ysb_branch_id) fetchSchoolsByBranch(form2.ysb_branch_id);
  }, [form2.ysb_branch_id, fetchSchoolsByBranch]);

  // =========================
  // Fetch tingkatan saat sekolah berubah
  // =========================
  const pickGradeLevelLabel = (gl) =>
    gl?.name_level ||
    "-";

  const pickGradeLevelValue = (gl) =>
    gl?.id ?? "";

  const fetchGradeLevelsBySchool = useCallback(
    async (schoolId, branchId) => {
      setLoadingGradeLevel(true);
      try {
        const res = await APIMS.get(
          `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&ysb_school_id=${schoolId}&level=${storageLevel}`,
          fetchParams
        );

        if (res?.status === 200) {
          let levels = res.data.data || [];

          //  filter client-side
          levels = levels.filter((x) => {
            const sid =
              x?.ysb_school_id ?? null;
            if (!sid) return true;
            return String(sid) === String(schoolId);
          });

          // Sort A-Z
          levels = [...levels].sort((a, b) =>
            String(pickGradeLevelLabel(a)).localeCompare(String(pickGradeLevelLabel(b)), "id", {
              sensitivity: "base",
            })
          );

          setGetDataGradeLevel(levels);

          // default tingkatan pertama
          if (levels.length > 0) {
            setForm2((prev) => ({
              ...prev,
              ysb_grade_level_id: String(pickGradeLevelValue(levels[0])),
            }));
          } else {
            setForm2((prev) => ({ ...prev, ysb_grade_level_id: "" }));
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoadingGradeLevel(false);
      }
    },
    [ascending, fetchParams, keyword, limit, page, storageLevel]
  );

  useEffect(() => {
    if (form2.ysb_school_id && form2.ysb_branch_id) {
      // reset tingkatan saat sekolah berubah, lalu fetch ulang
      setForm2((prev) => ({ ...prev, ysb_grade_level_id: "" }));
      setGetDataGradeLevel([]);
      fetchGradeLevelsBySchool(form2.ysb_school_id, form2.ysb_branch_id);
    }
  }, [form2.ysb_school_id, form2.ysb_branch_id, fetchGradeLevelsBySchool]);

  // =========================
  // Fetch dimensi sesuai payload filter
  // ========================

  const fetchDimensi = useCallback(async () => {
    if (
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_grade_level_id
    ) {
      setGetDataDimensi([]);
      setForm2((prev) => ({ ...prev, ysb_dimensi_id: "" }));
      return;
    }

    const academicYearId =
      selectedSemester?.ysb_academic_year_id ??
      selectedSemester?.academic_year_id ??
      selectedSemester?.ysb_academic_year?.id ??
      "";

    const payloadDimensi = {
      page: 1,
      limit: 10,
      ascending: 1,
      search: "",
      branch: "",
      level: storageLevel || "",
      ysb_academic_year_id: academicYearId,
      ysb_semester_id: form2.ysb_semester_id,
      ysb_branch_id: form2.ysb_branch_id,
      ysb_school_id: form2.ysb_school_id,
      ysb_grade_level_id: form2.ysb_grade_level_id,
      ysb_teacher_id: "",
    };

    setLoadingDimensi(true);

    try {
      const response = await APILA.get("/api/dimensis", {
        ...fetchParams,
        params: payloadDimensi,
      });

      if (response?.status === 200) {
        const dims = (response?.data?.data || []).filter(
          (d) => d?.status === undefined || Number(d?.status) === 1
        );

        setGetDataDimensi(dims);

        setForm2((prev) => ({
          ...prev,
          ysb_dimensi_id: dims.length > 0 ? dims[0]?.id || "" : "",
        }));
      }
    } catch (error) {
      console.error("Gagal mengambil data dimensi:", error);

      setGetDataDimensi([]);
      setForm2((prev) => ({
        ...prev,
        ysb_dimensi_id: "",
      }));
    } finally {
      setLoadingDimensi(false);
    }
  }, [
    fetchParams,
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_grade_level_id,
    selectedSemester,
    storageLevel,
  ]);

  useEffect(() => {
    fetchDimensi();
  }, [fetchDimensi]);

  // =========================
  // Filter complete
  // =========================
  const isFilterComplete =
    isFilterDirty &&
    !!form2.ysb_semester_id &&
    !!form2.ysb_branch_id &&
    !!form2.ysb_school_id &&
    !!form2.ysb_dimensi_id;

  // =========================
  // Fetch table data
  // =========================
  const GetResponseData = useCallback(async () => {
  if (
    !form2.ysb_semester_id ||
    !form2.ysb_branch_id ||
    !form2.ysb_school_id ||
    !form2.ysb_grade_level_id ||
    !form2.ysb_dimensi_id
  ) return;

  const params = {
    ysb_semester_id: form2.ysb_semester_id,
    level: storageLevel,
    branch: form2.ysb_branch_id,
    ysb_dimensi_id: form2.ysb_dimensi_id,
    ysb_school_id: form2.ysb_school_id,
    ysb_grade_level_id: form2.ysb_grade_level_id,
  };

  try {
    const response = await APILA.get(
      "/api/element-recaps-dimensi/full",
      {
        params,
        ...fetchParams,
      }
    );

    if (response?.status === 200) {
      setGetData(response.data.data || []);
    }
  } catch (error) {
    swal({
      title: "Gagal",
      text: error?.response?.data?.message || "Gagal mengambil data",
      icon: "error",
    });
  }
}, [form2, fetchParams, storageLevel]);

  // AUTO SELECT TAB
  useEffect(() => {
    if (getData.length > 0 && getData[0]?.data_element?.length > 0 && !selectedTab) {
      setSelectedTab(getData[0].data_element[0].name_element);
    }
  }, [getData, selectedTab]);

  // FIRST LOAD
  useEffect(() => {
    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_grade_level_id ||
      !form2.ysb_dimensi_id
    ) return;
  
    firstLoadDone.current = true;
  
    (async () => {
      setIsFetching(true);
      await GetResponseData(); 
      setHasSearched(true);
      setIsFirstLoad(false);
      setIsFilterDirty(false);
      setIsFetching(false);
    })();
  
  }, [
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_grade_level_id,
    form2.ysb_dimensi_id,
  ]);

  // Reset tab kalau filter berubah
  // kalau dimesis nya msh loading get nya tulisannya jgn gini dong
  useEffect(() => {
    setSelectedTab(null);
  }, [
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_grade_level_id,
    form2.ysb_dimensi_id,
  ]);

  // =========================
  // HANDLER perubahan filter
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm2((prev) => ({ ...prev, [name]: value }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };


  // =========================
  // BUTTON CARI
  // =========================
  const handleCari = async () => {
    // validasi
    if (!form2.ysb_semester_id || !form2.ysb_branch_id || !form2.ysb_school_id || !form2.ysb_grade_level_id || !form2.ysb_dimensi_id ) {
      swal({
        title: "Filter belum lengkap",
        text: "Pastikan Semester, Cabang, Sekolah, Tingkatan, dan Dimensi sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setSelectedTab(null);
    setGetData([]);
    setHasSearched(false);
    setIsFetching(true);

    try {
      await GetResponseData();
      setHasSearched(true);
      setIsFilterDirty(false);
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || "Terjadi kesalahan",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  };

  // =========================
  // INPUT NILAI (1-4) TANPA DESIMAL
  // =========================
  const handleForm3Change = (e) => {
    const { name, value } = e.target;

    // bolehin kosong
    if (value === "") {
      setForm3((prev) => ({ ...prev, [name]: "" }));
      return;
    }

    // Hanya izinkan 1 digit (1-4) ga boleh pecahan decimal
    if (/^[1-4]$/.test(value)) {
      setForm3((prev) => ({ ...prev, [name]: value }));
    }
  };

  // =========================
  // SAVE NILAI
  // =========================
  const originalValueRef = useRef(null);
  const popoverRef = useRef(null);

  const openScorePicker = (
      event,
      recapId,
      currentValue,
      isLogLocked,
      meta = {}
    ) => {
      if (!permission.update || isLogLocked || !isSelectedSemesterActive) return;
  
      const rect = event.currentTarget.getBoundingClientRect();
      const pickerWidth = 190;
      const pickerHeight = 56;
  
      let top = rect.top - pickerHeight - 8;
      let left = rect.left + rect.width / 2 - pickerWidth / 2;
  
      if (top < 8) top = rect.bottom + 8;
      if (left < 8) left = 8;
      if (left + pickerWidth > window.innerWidth - 8) {
        left = window.innerWidth - pickerWidth - 8;
      }
  
      originalValueRef.current = currentValue == null ? "" : String(currentValue);
  
      setUpdateID(recapId);
      setForm3({
        ysb_element_recap_id_id: recapId,
        ysb_sub_element_value: currentValue == null ? "" : String(currentValue),
      });
  
      setScorePicker({
        open: true,
        recapId,
        top,
        left,
        meta,
      });
    };
  
  
    useEffect(() => {
      if (!scorePicker.open) return;
  
      const close = () =>
        // setScorePicker({ open: false, recapId: null, top: 0, left: 0 });
        setScorePicker({ open: false, recapId: null, top: 0, left: 0, meta: null });
  
      const onKeyDown = (e) => {
        if (e.key === "Escape") close();
      };
  
      const onDocMouseDown = (e) => {
        const target = e.target;
  
        // klik di dalam popup -> jangan tutup
        if (popoverRef.current && popoverRef.current.contains(target)) return;
  
        // klik di input form nilai -> biarkan flow openScorePicker bekerja
        if (target.closest?.(".ysb-score-input")) return;
  
        // selain itu, tutup popup
        close();
      };
  
      document.addEventListener("keydown", onKeyDown);
      document.addEventListener("mousedown", onDocMouseDown);
      window.addEventListener("scroll", close, true);
      window.addEventListener("resize", close);
  
      return () => {
        document.removeEventListener("keydown", onKeyDown);
        document.removeEventListener("mousedown", onDocMouseDown);
        window.removeEventListener("scroll", close, true);
        window.removeEventListener("resize", close);
      };
    }, [scorePicker.open]);

  
  const saveForm3 = async (payload) => {
    const incomingRecapId = payload?.recapId ?? form3?.ysb_element_recap_id_id;
    const meta = payload?.meta ?? scorePicker?.meta ?? {};
    const newValue = payload?.newValue ?? (form3?.ysb_sub_element_value ?? "");
    const oldValue = payload?.oldValue ?? (originalValueRef.current ?? "");

    if (!isSelectedSemesterActive) {
      ToastError.fire({
        icon: "warning",
        title: "Semester tidak aktif. Nilai hanya dapat diinput pada semester aktif.",
      });
      setUpdateID(null);
      return;
    }

    if (!meta?.ysb_student_id || !meta?.ysb_sub_element_id) return;

    if (String(newValue) === String(oldValue)) {
      setUpdateID(null);
      return;
    }

    const saveKey = getCellKey(meta);
    setSavingKey(saveKey);

    const previousData = JSON.parse(JSON.stringify(getData || []));

    // cari recap id TERBARU dari state, jangan hanya percaya dari payload lama
    const latestCell =
      getData?.[0]?.data_element
        ?.flatMap((el) => el?.rekapan || [])
        ?.find((rekap) => safeStr(rekap?.ysb_student_id) === safeStr(meta?.ysb_student_id))
        ?.sub_elements
        ?.find((sub) => safeStr(sub?.ysb_sub_element_id) === safeStr(meta?.ysb_sub_element_id));

    const latestRecapId =
      latestCell?.ysb_element_recap_id || incomingRecapId || "default";

    const isDefaultId =
      !latestRecapId || safeStr(latestRecapId).toLowerCase() === "default";

    // optimistic update
    setGetData((prev) => updateLocalCellValue(prev, meta, newValue));

    try {
      const endpoint = isDefaultId
        ? `/api/element-recaps-dimensi-teacher/default`
        : `/api/element-recaps-dimensi-teacher/${latestRecapId}`;

      // payload create & update dibuat SAMA-SAMA lengkap
      const requestBody = {
        ysb_semester_id: meta?.ysb_semester_id || form2?.ysb_semester_id,
        // ysb_school_id: meta?.ysb_school_id || storageSchoolId,
        // ysb_teacher_id: meta?.ysb_teacher_id || storageTeacher,
        ysb_student_id: meta?.ysb_student_id,
        ysb_element_id: meta?.ysb_element_id,
        ysb_sub_element_id: meta?.ysb_sub_element_id,
        ysb_sub_element_value: newValue === "" ? null : Number(newValue),
        user_id: output_id_user,
      };

      const response = await APILA.put(endpoint, requestBody, fetchParams);

      if (response?.status === 200) {
        let finalRecapId = latestRecapId;

        if (isDefaultId) {
          const createdRecapId = resolveCreatedRecapId(response);

          if (createdRecapId) {
            finalRecapId = createdRecapId;

            setGetData((prev) =>
              updateLocalCellValue(prev, meta, newValue, createdRecapId)
            );

            setForm3((prev) => ({
              ...prev,
              ysb_element_recap_id_id: createdRecapId,
            }));
          }
        }

        setScorePicker((prev) => ({
          ...prev,
          recapId: finalRecapId,
          meta: {
            ...(prev?.meta || {}),
            ...meta,
            ysb_element_recap_id: finalRecapId,
          },
        }));

        setUpdateID(finalRecapId);

        ToastSuccess.fire({
          icon: "success",
          title: "Nilai berhasil disimpan",
        });
      }
    } catch (error) {
      setGetData(previousData);

      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          error.message ||
          "Gagal menyimpan nilai",
      });
    } finally {
      setSavingKey(null);
    }
  };

 const pickScore = async (value) => {
  const recapId = scorePicker.recapId;
  const meta = scorePicker.meta;
  if (!meta) return;

  const newValue = String(value);
  const oldValue = originalValueRef.current ?? "";

  setForm3({
    ysb_element_recap_id_id: recapId,
    ysb_sub_element_value: newValue,
  });

  if (String(newValue) === String(oldValue)) {
    setScorePicker({ open: false, recapId: null, top: 0, left: 0, meta: null });
    setUpdateID(null);
    return;
  }

  await saveForm3({ recapId, meta, newValue, oldValue });

  setScorePicker({ open: false, recapId: null, top: 0, left: 0, meta: null });
};


  const clearScore = async () => {
  const recapId = scorePicker.recapId;
  const meta = scorePicker.meta;
  if (!meta) return;

  const newValue = "";
  const oldValue = originalValueRef.current ?? "";

  setForm3({
    ysb_element_recap_id_id: recapId,
    ysb_sub_element_value: newValue,
  });

  if (String(oldValue) === "") {
    setScorePicker({ open: false, recapId: null, top: 0, left: 0, meta: null });
    setUpdateID(null);
    return;
  }

  await saveForm3({ recapId, meta, newValue, oldValue });

  setScorePicker({ open: false, recapId: null, top: 0, left: 0, meta: null });
};


  // =========================
  // RATA-RATA
  // =========================
  const calculateAverage = (subElements) => {
    const values = subElements
      .map((s) => s.ysb_sub_element_value)
      .filter(
        (v) =>
          v !== null &&
          v !== "" &&
          v !== undefined &&
          !isNaN(Number(v))
      )
      .map(Number);

    if (values.length === 0) return 0;

    const total = values.reduce((a, b) => a + b, 0);
    return Number((total / values.length ?? 0).toFixed(2));
  };

  // SEARCH 
  useEffect(() => {
    setSearchMap({});
  }, [form2.ysb_semester_id, form2.ysb_dimensi_id]);

  // =========================
  // MODAL KUNCI NILAI
  // =========================
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => {
    if (!form2.ysb_semester_id || !form2.ysb_school_id) {
      swal({
        title: "Data belum lengkap",
        text: "Semester dan Sekolah wajib dipilih",
        icon: "warning",
      });
      return;
    }
    setShowModal(true);
  };

  // =========================
  // MODAL CANCEL KUNCI NILAI
  // =========================
  const [showCancelModal, setShowCancelModal] = useState(false);

  const handleOpenCancelModal = () => {
    if (!form2.ysb_semester_id || !form2.ysb_school_id) {
      swal({
        title: "Data belum lengkap",
        text: "Semester dan Sekolah wajib dipilih",
        icon: "warning",
      });
      return;
    }
    setShowCancelModal(true);
  };

  const toTitleCase = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";
    return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
  };

  return (
    <>
      <style>{shimmerStyle}</style>

      <div className="body module-page assessment-page">
        <HeadPage />

        <div className="body-content module-content mt-2">
          <div className="assessment-mode-tabs">
            <div>
              <button
                className="btn assessment-mode-tab active"
                style={{
                  fontSize: "15px",
                  padding: "5px 10px",
                  marginTop: "-2px",
                  borderRadius: "10px 10px 0px 0px",
                  backgroundColor: "#076db5ff",
                  color: "#fff",
                }}
              >
                Penilaian Guru
              </button>
            </div>

            <div className="ml-2">
              <button className="btn assessment-mode-tab">
                <Link to="/element-recaps-dimensi/recaps-head-new">
                  Penilaian Kepala Sekolah
                </Link>
              </button>
            </div>
          </div>
          <hr className="assessment-mode-divider" />

          {/* FILTER */}
          {isTabletOrMobile ? (
            <div className="assessment-filter-card assessment-filter-mobile">
              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                <select
                  className="assessment-filter-select mr-2"
                  name="ysb_semester_id"
                  value={form2.ysb_semester_id}
                  onChange={handleChange}
                  style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}
                > 
                  <option value="" hidden>
                    {namaTA} (Semester {namaSmstr})
                  </option>
                  {getDataSemesterMap.map((user, index) => (
                    <option key={index} value={user?.id}>
                      {user?.name_year} (Semester {user?.semester}){Number(user?.status) === 1 ? " • Aktif" : ""}
                    </option>
                  ))}
                </select>
              </Row>


              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                <select
                  className="assessment-filter-select mr-2"
                  name="ysb_branch_id"
                  value={form2.ysb_branch_id}
                  onChange={handleChange}
                  style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}
                >
                  <option value="" hidden>
                    Pilih Cabang
                  </option>
                  {getDataBranch.map((user, index) => (
                    <option key={index} value={user?.branch_code}>
                      {user?.branch_name}
                    </option>
                  ))}
                </select>
              </Row>

              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                <select
                  className="assessment-filter-select mr-2"
                  name="ysb_school_id"
                  value={form2.ysb_school_id}
                  onChange={handleChange}
                  disabled={loadingSchool}
                  style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    backgroundColor: loadingSchool ? "#f5f5f5" : "#fff",
                    cursor: loadingSchool ? "not-allowed" : "pointer",
                  }}
                >
                  <option value="" hidden>
                    {loadingSchool ? "Memuat data sekolah..." : "Pilih Sekolah"}
                  </option>

                  {!loadingSchool &&
                    getDataSchool.map((user, index) => (
                      <option key={index} value={user?.school_code}>
                        {user?.school_name}
                      </option>
                  ))}
                </select>
              </Row>

              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                <select
                  className="assessment-filter-select mr-2"
                  name="ysb_grade_level_id"
                  value={form2.ysb_grade_level_id}
                  onChange={handleChange}
                  disabled={loadingGradeLevel}
                  style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    backgroundColor: loadingGradeLevel ? "#f5f5f5" : "#fff",
                    cursor: loadingGradeLevel ? "not-allowed" : "pointer",
                  }}
                >
                  <option value="" hidden>
                    {loadingGradeLevel ? "Memuat data tingkatan..." : "Pilih Tingkatan"}
                  </option>

                  {!loadingGradeLevel &&
                    getDataGradeLevel.map((gl, index) => (
                      <option key={index} value={String(pickGradeLevelValue(gl))}>
                        {pickGradeLevelLabel(gl)}
                      </option>
                    ))}
                </select>
              </Row>

              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                <select
                  className="leger-filter-select"
                  name="ysb_dimensi_id"
                  value={form2.ysb_dimensi_id}
                  onChange={handleChange}
                  disabled={loadingDimensi}
                  style={{
                    backgroundColor: loadingDimensi ? "#f5f5f5" : "#fff",
                    cursor: loadingDimensi ? "not-allowed" : "pointer",
                  }}
                >

                  {loadingDimensi ? ( <option value="">Memuat dimensi...</option> ) : getDataDimensi.length === 0 ? 
                    ( <option value="">Belum ada dimensi</option> ) : (
                        <>
                          <option value="" hidden>
                            Pilih Dimensi
                          </option>

                          {getDataDimensi.map((user, index) => (
                            <option key={index} value={user?.id}>
                              {user?.name_dimensi}
                            </option>
                          ))}
                        </>
                  )}
                </select>
              </Row>


              <Row style={{ marginTop: "12px", padding: "0 12px" }}>
                <button
                  onClick={handleCari}
                  disabled={!isFilterComplete}
                  className="btn assessment-filter-button"
                  style={{
                    fontSize: "13px",
                    padding: "10px 16px",
                    borderRadius: "12px",
                    backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                    color: "#fff",
                    cursor: !isFilterComplete ? "not-allowed" : "pointer",
                  }}
                >
                  Cari
                </button>
              </Row>
            </div>
          ) : (
            <> 
            <div className="assessment-filter-card mb-3">
                {loading ? (
                  <>
                    <div className="mb-3 d-flex">
                      <div className="shimmer shimmer-select mr-3" style={{width:230, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-3" style={{width:230, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-3" style={{width:230, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-3" style={{width:230, borderRadius: "12px"}} />
                    </div>
                    
                    <div className=" d-flex">
                      <div className="shimmer shimmer-select mr-3" style={{width:230, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-3" style={{width:230, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-3" style={{width:230, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-3" style={{width:230, borderRadius: "12px"}} />
                    </div>
                  </>
                ) : (
                  <div className="leger-filter-grid leger-filter-grid-sync">
                    <div className="leger-filter-field">
                      <label className="leger-filter-label">Semester</label>
                      <select
                        className="leger-filter-select"
                        name="ysb_semester_id"
                        value={form2.ysb_semester_id}
                        onChange={handleChange}
                      >
                        <option value="" hidden>
                          {namaTA} (Semester {namaSmstr})
                        </option>
                        {getDataSemesterMap.map((user, index) => (
                          <option key={index} value={user?.id}>
                            {user?.name_year} (Semester {user?.semester})
                            {/* {user?.name_year} (Semester {user?.semester}){Number(user?.status) === 1 ? " • Aktif" : ""} */}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="leger-filter-field">
                      <label className="leger-filter-label">Cabang</label>
                      <select
                        className="leger-filter-select"
                        name="ysb_branch_id"
                        value={form2.ysb_branch_id}
                        onChange={handleChange}
                      >
                        <option value="" hidden>Pilih Cabang</option>
                        {getDataBranch.map((user, index) => (
                          <option key={index} value={user?.branch_code}>
                            {user?.branch_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="leger-filter-field">
                      <label className="leger-filter-label">Sekolah</label>
                      <select
                        className="leger-filter-select"
                        name="ysb_school_id"
                        value={form2.ysb_school_id}
                        onChange={handleChange}
                        disabled={loadingSchool}
                      >
                        <option value="" hidden>
                          {loadingSchool ? "Memuat data sekolah..." : "Pilih Sekolah"}
                        </option>
                        {!loadingSchool &&
                          getDataSchool.map((user, index) => (
                            <option key={index} value={user?.school_code}>
                              {user?.school_name}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="leger-filter-field">
                      <label className="leger-filter-label">Tingkatan</label>
                      <select
                        className="leger-filter-select"
                        name="ysb_grade_level_id"
                        value={form2.ysb_grade_level_id}
                        onChange={handleChange}
                        disabled={loadingGradeLevel}
                      >
                        <option value="" hidden>
                          {loadingGradeLevel ? "Memuat data tingkatan..." : "Pilih Tingkatan"}
                        </option>
                        {!loadingGradeLevel &&
                          getDataGradeLevel.map((user, index) => (
                            <option key={index} value={user?.id}>
                              {user?.name_level}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="leger-filter-field">
                      <label className="leger-filter-label">Dimensi</label>
                     
                      <select
                        className="leger-filter-select"
                        name="ysb_dimensi_id"
                        value={form2.ysb_dimensi_id}
                        onChange={handleChange}
                        disabled={loadingDimensi}
                        style={{
                          backgroundColor: loadingDimensi ? "#f5f5f5" : "#fff",
                          cursor: loadingDimensi ? "not-allowed" : "pointer",
                        }}
                      >
                        {loadingDimensi ? (
                          <option value="">Memuat dimensi...</option>
                        ) : getDataDimensi.length === 0 ? (
                          <option value="">Belum ada dimensi</option>
                        ) : (
                          <>
                            <option value="" hidden>
                              Pilih Dimensi
                            </option>

                            {getDataDimensi.map((user, index) => (
                              <option key={index} value={user?.id}>
                                {user?.name_dimensi}
                              </option>
                            ))}
                          </>
                        )}
                      </select>
                    </div>

                    <button
                      onClick={handleCari}
                      disabled={!isFilterComplete}
                      className="btn assessment-filter-button"
                      style={{
                        fontSize: "13px",
                        padding: "10px 16px",
                        borderRadius: "12px",
                        backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                        color: "#fff",
                        cursor: !isFilterComplete ? "not-allowed" : "pointer",
                      }}
                    >
                      Cari
                    </button>

                    <button 
                      className="btn assessment-toolbar-button assessment-lock-button ml-2" 
                      onClick={() => handleOpenModal()} 
                      style={{
                        fontSize: '13px',  
                        padding: "10px 16px",
                        borderRadius: "12px", 
                        backgroundColor:"#1ab4ecff",
                        color: "#fff"}}
                      >
                        <FontAwesomeIcon icon={faKey} /> 
                        Kunci Nilai 
                    </button>

                    <button 
                      className="btn assessment-toolbar-button assessment-unlock-button ml-2" 
                      onClick={() => handleOpenCancelModal()} 
                      style={{
                        fontSize: '13px',  
                        padding: "10px 16px",
                        borderRadius: "12px", 
                        backgroundColor:"rgb(0, 0, 0)", color: "#fff"
                      }}
                    >
                      Batal Kunci
                    </button>
                  </div>
                )}
              </div>
            </>
            
          )}

          {form2.ysb_semester_id && !isSelectedSemesterActive && (
            <div className="assessment-status-banner" role="status">
              <span className="assessment-status-dot" />
              <div>
                <strong>Semester tidak aktif.</strong> Data nilai tetap dapat dilihat, tetapi input nilai dinonaktifkan. Penilaian hanya bisa diinput pada semester yang berstatus aktif.
              </div>
            </div>
          )}

        
          {/* LOADER*/}
          {isFetching && (
            <div className="text-center" style={{ padding: "10px 0" }}>
              <span style={{color: "#2e52aeff", fontWeight: "500"}}><PulseLoader color={'#3f5bea'} size={12}/></span>
            </div>
          )}

          {/* MODE HANYA LIHAT */}
          {/* TABLE */}
          {hasSearched && !isFetching && (
            <>
              {isNilaiReadOnlyRole && (
                <div className="head-assessment-readonly-banner">
                  <span className="head-assessment-readonly-icon">
                    i
                  </span>

                  <div>
                    <strong>
                      Mode Hanya Lihat
                    </strong>

                    <div>
                      {isPengawasAdab
                        ? "Role Pengawas Adab tidak dapat menginput atau mengubah nilai. Data penilaian hanya dapat dilihat."
                        : "Role Developer tidak dapat menginput atau mengubah nilai. Data penilaian hanya dapat dilihat."}
                    </div>
                  </div>
                </div>
              )}

              <Tabs id="uncontrolled-tab-example" activeKey={selectedTab} onSelect={(k) => setSelectedTab(k)} className="assessment-tabs mb-3 mt-4 nav-tabs">
                {(getData?.[0]?.data_element || []).map((element, eIdx) => (
                  <Tab key={element?.id || eIdx} eventKey={element?.name_element} title={element?.name_element} className="nav-item">
                    <div className="assessment-element-info">
                      <h5 className="mt-2 mb-2">{element?.description}</h5>
                    </div>

                    <div className="mt-3">
                      <div className="module-search-wrap assessment-search-wrap">
                        <input
                          className="module-search-input assessment-search-input"
                          placeholder="Cari Siswa / NISN"
                          value={searchMap[element?.id] || ""}
                          onChange={(e) =>
                            setSearchMap((prev) => ({
                              ...prev,
                              [element?.id]: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>

                    <Col xl="12" sm="12">
                      <div className="mt-3">
                        <div className="module-table-card assessment-table-card">
                          <div className="module-table-scroll assessment-table-scroll">
                            <table className="module-table assessment-table" id="basic-datatable">
                              <thead>
                                <tr>
                                  <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>No</th>
                                  <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>Nama</th>
                                  <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>Nisn</th>

                                  {element?.rekapan?.[0]?.sub_elements?.map((sub, idx) => (
                                    <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }} key={sub?.ysb_sub_element_id || idx}>
                                      {sub?.ysb_sub_element_name || sub?.description}
                                    </th>
                                  ))}
                                  <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff" }}>Rata-Rata</th>
                                </tr>
                              </thead>

                              <tbody>
                                {(() => {
                                  const q = String(searchMap[element?.id] || "").trim().toLowerCase();

                                  const rows = [...(element?.rekapan || [])].sort((a, b) =>
                                    String(a?.name_student || "").localeCompare(
                                      String(b?.name_student || ""),
                                      "id",
                                      { sensitivity: "base" }
                                    )
                                  );

                                  const filteredRows = !q
                                    ? rows
                                    : rows.filter((r) => {
                                        const name = String(r?.name_student || "").toLowerCase();
                                        const nisn = String(r?.nisn || "").toLowerCase();
                                        return name.includes(q) || nisn.includes(q);
                                      });

                                  const subLen = element?.rekapan?.[0]?.sub_elements?.length || 0;
                                  const colSpan = 4 + subLen; 

                                  if (filteredRows.length === 0) {
                                    return (
                                      <tr>
                                        <td colSpan={colSpan} className="module-empty-state assessment-empty-state">
                                          Data tidak ditemukan
                                        </td>
                                      </tr>
                                    );
                                  }

                                  return filteredRows.map((rekap, rowIdx) => (
                                    <tr key={rekap?.ysb_element_recap_id} className="ysb-row-hover">
                                      <td className="text-center"><span className="assessment-number-badge">{rowIdx + 1}</span></td>
                                      <td style={{ lineHeight: "2" }}>{toTitleCase(rekap?.name_student)}</td>
                                      <td style={{ lineHeight: "2", textAlign: "center" }}>{rekap?.nisn}</td>

                                      {rekap?.sub_elements?.map((sub, i) => {
                                        const subRecapIdVal = sub?.ysb_element_recap_id;
                                        const subValueLocal = sub?.ysb_sub_element_value;
                                        const isEditingLocal = updateId === subRecapIdVal;

                                        const isLogLocked = String(sub?.ysb_log_value_status) === "0";
                                        const isScoreDisabled = isLogLocked || !isSelectedSemesterActive || !permission.update;

                                        const cellMeta = {
                                        ysb_element_recap_id: subRecapIdVal,
                                        ysb_semester_id: form2?.ysb_semester_id,
                                        // ysb_school_id: storageSchoolId,
                                        // ysb_teacher_id: storageTeacher,
                                        ysb_student_id: rekap?.ysb_student_id,
                                        ysb_element_id: sub?.ysb_element_id || element?.id,
                                        ysb_sub_element_id: sub?.ysb_sub_element_id,
                                      };

                                      const cellKey = getCellKey(cellMeta);

                                      const handleClickCell = (e) => {
                                        openScorePicker(
                                          e,
                                          subRecapIdVal,
                                          subValueLocal,
                                          isLogLocked,
                                          cellMeta
                                        );
                                      };

                                        return (
                                          <td key={subRecapIdVal || i} style={{ lineHeight: "2" }} className="text-center">
                                          {/* {savingId === subRecapIdVal ? ( */}
                                          {savingKey === cellKey ? (
                                            <div className="d-flex justify-content-center mt-2">
                                              <ClipLoader size={14} color="#3f5bea" />
                                            </div>
                                          ) : (
                                            <input
                                              type="text"
                                              onClick={(e) => handleClickCell(e)}
                                              value={subValueLocal == null ? "" : subValueLocal}
                                              disabled={isScoreDisabled}
                                              title={!isSelectedSemesterActive ? "Semester tidak aktif - hanya dapat melihat nilai" : isLogLocked ? "Nilai terkunci" : !permission.update ? "Tidak memiliki akses untuk mengubah nilai" : "Klik untuk input nilai"}
                                              className={`ysb-score-input text-center ${isScoreDisabled ? "ysb-input-disabled" : ""}`}
                                              style={{
                                                border: "1px solid #e7eefa",
                                                borderRadius: "5px",
                                                width: "40px",
                                                backgroundColor: isScoreDisabled ? "#f3f5f8" : "#fff",
                                                cursor: isScoreDisabled ? "not-allowed" : "pointer",
                                              }}
                                              readOnly
                                            />
                                          )

                                          }
                                        </td>
                                        );
                                      })}

                                      <td style={{ lineHeight: "2" }} className="text-center fw-bold">
                                        {(() => {
                                          const v = Number((rekap?.average ?? 0).toFixed(2));
                                          return v % 1 === 0 ? v.toFixed(0) : v.toString();
                                        })()}
                                      </td>
                                    </tr>
                                  ));
                                })()}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </Col>

                    <Confirm
                      show={showModal}
                      onHide={() => setShowModal(false)}
                      payload={{
                        ysb_semester_id: form2.ysb_semester_id,
                        ysb_school_id: form2.ysb_school_id,
                        user_id: output_id_user,
                      }}
                      onSuccess={() => {
                        GetResponseData();
                      }}
                    />

                    <CancelNilai
                      show={showCancelModal}
                      onHide={() => setShowCancelModal(false)}
                      payload={{
                        ysb_semester_id: form2.ysb_semester_id,
                        ysb_school_id: form2.ysb_school_id,
                        user_id: output_id_user,
                      }}
                      onSuccess={() => {
                        GetResponseData(); 
                      }}
                    />

                  </Tab>
                ))}
              </Tabs>
            </>
            
          )}
        </div>
      </div>

       {scorePicker.open && (
              <div
                className="ysb-score-popover"
                style={{ top: scorePicker.top, left: scorePicker.left }}
                onMouseDown={(e) => e.stopPropagation()}
              >
                <div className="ysb-score-popover-grid ysb-score-popover-grid-inline">
                  {[1, 2, 3, 4].map((n) => (
                    <button
                      key={n}
                      type="button"
                      className="ysb-score-btn"
                      onMouseDown={(e) => {
                        e.preventDefault();
                        pickScore(n);
                      }}
                    >
                      {n}
                    </button>
                  ))}
      
      
                  <button
                    type="button"
                    className="ysb-score-btn ysb-score-btn-trash"
                    title="Hapus nilai"
                    onMouseDown={(e) => {
                      e.preventDefault();
                      clearScore();
                    }}
                  >
                    <FiTrash2 size={16} color="red" />
                  </button>
      
                </div>
              </div>
            )}
    </>
    
  );
}
